import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import Shebei from '@/views/Shebei'
import News from '@/views/News'
import Contact from '@/views/Contact'
import Article from '@/views/Article'
import Nofind from '@/views/Nofind'

Vue.use(VueRouter)

const routes = [{
		path: '/home',
		name: 'Home',
		component: Home,
		meta: {
			title: '粤之彩印刷'
		}
	},
	{
		path: '/about',
		name: 'About',
		component: About,
		meta: {
			title: '关于我们'
		}
	},

	{
		path: '/shebei',
		name: 'Shebei',
		component: Shebei,
		meta: {
			title: '作品欣赏'
		}
	},
	{
		path: '/news',
		name: 'News',
		component: News,
		meta: {
			title: '新闻资讯'
		}
	},

	{
		path: '/contact',
		name: 'Contact',
		component: Contact,
		meta: {
			title: '联系我们'
		}
	},
	{
		path: "/article",
		name: 'Article',
		component: Article,
		meta: {
			title: '文章'
		}
	},
	{
		path: '/',
		redirect: '/home'
	},


	{
		path: '*',
		name: '404',
		component: Nofind,
		meta: {
			title: '404'
		}
	}


]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
//全局前置守卫
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	//360代码
	setTimeout(() => {
		(function(b, a, e, h, f, c, g, s) {
			b[h] = b[h] || function() {
				(b[h].c = b[h].c || []).push(arguments)
			};
			b[h].s = !!c;
			g = a.getElementsByTagName(e)[0];
			s = a.createElement(e);
			s.src = "//s.union.360.cn/" + f + ".js";
			s.defer = !0;
			s.async = !0;
			g.parentNode.insertBefore(s, g)
		})(window, document, "script", "_qha", 457487, false);
	}, 0);
	next();
})


export default router
